var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-btn',{staticClass:"text-transform basker-text",attrs:{"href":_vm.url,"to":_vm.to,"target":"_blank"}},[_c('span',{staticStyle:{"color":"#ffdd00"}},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }